import { Navigate } from "react-router-dom";
import { useApp } from "../context";
export function OnboardingGuard({children}: {children: React.ReactNode}) {
 const {state}=useApp();
 if (!state.onboardingComplete) return <>{children}</>;
 const purpose = state.user.userIntent === "manage-stress" ? "settle" : state.user.userIntent === "prepare-ahead" ? "prepare" : state.user.userIntent === "build-skills" ? "focus" : null;
 return <Navigate to={purpose ? `/practice?purpose=${purpose}` : "/"} replace/>;
}
